import { getContentByLocale } from "../content";
import { useI18n } from "../i18n";
import { ContactView } from "../views/home/ContactView";
import { SocialLinks } from "../components/social/SocialLinks";
import { PageSeo } from "../components/seo/PageSeo";

export function ContactPage() {
  const { locale } = useI18n();
  const content = getContentByLocale(locale);

  return (
    <>
      <PageSeo
        title={`${content.contact.title} | ${content.seo.defaultTitle}`}
        description={content.contact.description}
      />
      <ContactView
        title={content.contact.title}
        description={content.contact.description}
        submitLabel={content.contact.submitLabel}
      />
      <SocialLinks items={content.social} />
    </>
  );
}
